export function getInviteStatusTone(state) {
  if (state === 'accepted') return 'success';
  if (state === 'revoked') return 'destructive';
  return 'neutral';
}
